<template>
  <div class="tab_wrapper_placeholder">
    <ul class="tab_wrapper">
      <li class="tab_cell">
         <router-link to="/search">
           <p class="tab_cell_ele sq">
             <span>搜券</span>
           </p>
         </router-link>
      </li>
      <li class="tab_cell">
         <router-link to="/goodsCoupon">
           <p class="tab_cell_ele tq">
             <span>淘券</span>
           </p>
         </router-link>
      </li>
      <li class="tab_cell">
         <router-link to="/welfare">
           <p class="tab_cell_ele fl">
             <span>福利</span>
           </p>
         </router-link>
      </li>
      <li class="tab_cell">
         <router-link to="/quan">
           <p class="tab_cell_ele qfq">
             <span>券粉圈</span>
           </p>
         </router-link>
      </li>
      <li class="tab_cell">
         <router-link to="/userCenter">
           <p class="tab_cell_ele wd">
             <span>我的</span>
           </p>
         </router-link>
      </li>
    </ul>
  </div>

</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
  export default {
    name:"v-footer"
  }
</script>

<style lang="stylus">
.tab_wrapper_placeholder
  width:100%
  height:110px
  .tab_wrapper
    width:100%
    display:flex
    position:fixed
    left:0px
    bottom:0px
    box-sizing:border-box
    height:110px
    padding-top:10px;
    border-top:1px solid #c5c5c5
    background:#fff
    z-index:999
    .tab_cell
      flex:1
      text-align:center
      .tab_cell_ele
        padding-top:57px;
        background-repeat:no-repeat;
        background-size:57px 57px;
        background-position:center top
        &.sq
          background-image:url(../../images/tab/middle.png)
        &.tq
          background-image:url(../../images/tab/tq.png)
        &.fl
          background-image:url(../../images/tab/fl.png)
        &.qfq
          background-image:url(../../images/tab/fans.png)
        &.wd
          background-image:url(../../images/tab/mine.png)


</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue